/**
 * @description 會員基本資料 標題顯示用
*/
export enum MemberProfileTitle {
  /** 註冊 step2 頁面 */
  SignupStep = '會員資料',
  /** 會員資料維護頁面 */
  Maintain = '會員資料維護'
}
